import { Search as SearchIcon, XIcon } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';

import { Input } from '@/shared/components/shadcn/input';
import { cn } from '@/shared/utils/index';

interface Props {
  className?: string;
  initialValue?: string;
  onSubmit?: (query: string) => void;
  placeholder?: string;
  onClear?: () => void;
}

export function SearchInput({ className, onSubmit, placeholder, initialValue, onClear }: Props) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [inputValue, setInputValue] = useState(initialValue);

  const handleClear = () => {
    setInputValue('');
    onClear?.();
  };

  useEffect(() => {
    setInputValue(initialValue);
  }, [initialValue]);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        const inputValue = inputRef.current?.value;
        if (inputValue != null) {
          onSubmit?.(inputValue);
        }
      }}
      className={cn('relative h-10 w-full', className)}
    >
      <button
        type="submit"
        className={cn([
          'text-muted-foreground cursor-pointer',
          'absolute top-1/2 left-3 -translate-y-1/2 transform',
        ])}
      >
        <SearchIcon size={16} />
      </button>
      <Input
        type="text"
        ref={inputRef}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        placeholder={placeholder}
        className="h-full w-full bg-white pl-9 text-sm"
      />
      {inputValue && onClear && (
        <button
          type="button"
          className="absolute top-1/2 right-3 flex h-4 w-4 -translate-y-1/2 transform cursor-pointer items-center justify-center rounded-full bg-gray-200"
          onClick={handleClear}
        >
          <XIcon className="size-2.5 text-gray-500" />
        </button>
      )}
    </form>
  );
}
